import algoliasearch, { SearchClient } from 'algoliasearch/lite';

export type SearchClientType = SearchClient | null;

export function getSearchClient(): SearchClientType {
   return App.algoliaConfig?.appId
      ? algoliasearch(App.algoliaConfig.appId, App.algoliaConfig.apiKey)
      : null;
}

export const PUBLIC_KEY = (App.algoliaConfig?.apiKey as string) || '';

const indexes: Record<string, string[]> = App.algoliaConfig?.indexNamesByObjectType || {};

const specialIndexToDocTypeMap: Record<string, string> = {
   'searchpage': 'pages',
   'item': 'item',
   'wp_searchable_posts': 'news',
};

const mapIndexToDocType = (index: string): string => specialIndexToDocTypeMap[index] || index;

export function getIndexes(): Record<string, string[]> {
   const wantedDocTypes = App.algoliaConfig?.defaultDoctypes || [];
   const filtered = Object.entries(indexes)
      .map(([index, value]) => [mapIndexToDocType(index), value] as [string, string[]])
      .filter(([docType]) => wantedDocTypes.includes(docType));

   return toFirstIndexes(Object.fromEntries(filtered));
}

export function isProUser(): boolean {
   const storeCode = App?.userPreferredStoreCode || '';
   return App?.priceTiers[storeCode]?.test(/pro/i) || false;
}

function toFirstIndexes(indices: Record<string, string[]>): Record<string, string[]> {
   return Object.fromEntries(
      Object.entries(indices).map(([doctype, indexNames]) => [doctype, [indexNames[0]]])
   );
}
